module.exports = __webpack_public_path__ + "de993a9aa104348968e026939851556e.png";